let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4PQXU"), load("5joXW"), load("4fCJZ"), load("1epse"), load("6H998")]).then(() => parcelRequire('bbp2J'));